import { render } from "./IconRightArrow.vue?vue&type=template&id=42969840"
import script from "./IconRightArrow.vue?vue&type=script&lang=ts"
export * from "./IconRightArrow.vue?vue&type=script&lang=ts"
script.render = render

export default script